export default {
  label: 'Publicaciones verificadas',
  placeholder: 'Todas',
  items: {
    all: 'Todas',
    onlyChecked: 'Solo Verificadas',
    onlyUnchecked: 'Solo No Verificadas',
  },
};
